import Vue from 'vue';
import Router, { Route } from 'vue-router';
import {
  Position,
} from 'vue-router/types/router';

import {
  requestRepeatStorage,
} from '@/plugins/request-repeat-storage';
import {
  checkAuthorization,
} from '@/plugins/router-hooks/check-authorization';
import {
  setToken,
} from '@/plugins/router-hooks/set-token';
import {
  updateProfile,
} from '@/plugins/router-hooks/update-profile';
import {
  routes,
} from '@/routes';
import {
  NavigationGuardNext,
} from '@/store/types';

import {
  store,
} from './store';

Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (): Position => ({
    x: 0,
    y: 0,
  }),
});

router.beforeEach(setToken(store, router));
router.beforeEach(checkAuthorization(store));
router.beforeEach(updateProfile(store));
router.beforeEach(
  (to: Route, from: Route, next: NavigationGuardNext) => {
    requestRepeatStorage.resetWatcher();
    next();
  },
);

export default router;
